import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import './AuthEditor.css'


class AuthEditor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      error: null,
    }
  }

  componentDidUpdate() {
    const error = this.validate()
    if (this.state.error !== error) {
      setTimeout(() => {
        this.setState({
          error,
        }, () => {
          if (!this.props.onValidate) {
            return
          }
          this.props.onValidate(error === null)
        })
      }, 10)
    }
  }

  validate() {
    if (!this.props.base_require_auth) {
      return null
    }
    if (!this.props.require_auth) {
      return 'コピー元テストは認証が必要なテストであるため、認証なしでのアクセスは許可できません。'
    }
    const base_whitelist = (this.props.base_whitelist_auth || '')
      .split(';').map(d => d.trim()).filter(d => d.length > 0)
    if (base_whitelist.length === 0) {
      return null
    }
    const whitelist = (this.props.whitelist_auth || '')
      .split(';').map(d => d.trim()).filter(d => d.length > 0)
    if (whitelist.length === 0) {
      return `コピー元テストで許可されているGoogleアカウント ${this.props.base_whitelist_auth} に対してのみ許可可能です。`
    }
    if (whitelist.some(d => !base_whitelist.includes(d))) {
      return `コピー元テストで許可されていないGoogleアカウントが許可されています。Googleアカウント ${this.props.base_whitelist_auth} に対してのみ許可可能です。`
    }
    return null
  }

  requireAuthChange(ev) {
    if (!this.props.onChange) {
      return
    }
    if (ev.target.value === 'true-myaccount') {
      this.props.onChange(true, `@${this.props.userEmail.split('@')[1]}`)
      return
    }
    if (ev.target.value === 'true-accountlist') {
      this.props.onChange(true, this.props.whitelist_auth ? `${this.props.whitelist_auth};` : '')
      return
    }
    this.props.onChange(ev.target.value === 'true', null)
  }

  whitelistChange(ev) {
    if (!this.props.onChange) {
      return
    }
    this.props.onChange(true, ev.target.value)
  }

  getRequireAuthOption() {
    if (!this.props.require_auth) {
      return 'false'
    }
    if (this.props.whitelist_auth === undefined || this.props.whitelist_auth === null) {
      return 'true'
    }
    if (this.props.userEmail && !this.props.userEmail.endsWith('@gmail.com') &&
      this.props.whitelist_auth === `@${this.props.userEmail.split('@')[1]}`) {
      return 'true-myaccount'
    }
    return 'true-accountlist'
  }

  render() {
    return <div className='AuthEditor'>
      {this.props.readonly ? (this.props.require_auth ? '必要' : '不要') : <div>
        <Form.Control
          data-test-task-require-auth
          as='select'
          onChange={ev => this.requireAuthChange(ev)}
          value={this.getRequireAuthOption()}>
          <option value='false'>不要</option>
          <option value='true'>必要 - 全てのGoogleアカウントを許可</option>
          {this.props.userEmail && !this.props.userEmail.endsWith('@gmail.com') &&
            <option value='true-myaccount'>必要 - 組織 @{this.props.userEmail.split('@')[1]} のGoogleアカウントを許可</option>}
          <option value='true-accountlist'>必要 - 許可対象のGoogleアカウントを指定</option>
        </Form.Control>
        {this.getRequireAuthOption() === 'true-accountlist' && <div className='AuthAccounts'>
            Googleアカウント(@アカウント名, セミコロン;で区切って複数指定可能): <Form.Control
              data-test-account-list
              placeholder='Googleアカウント1(@からはじめる);Googleアカウント2(@からはじめる);...'
              defaultValue={this.props.whitelist_auth}
              onChange={e => this.whitelistChange(e)} />
          </div>}
        {this.state.error && <div className='ValidationError'>
          <FontAwesomeIcon icon={faExclamationTriangle} />
          {this.state.error}
        </div>}
      </div>}
    </div>
  }
}

export default AuthEditor;
